export default {
  formId: "change-password-form",
  formField: {
    oldPassword: {
      name: "oldPassword",
      label: "Current Password",
      type: "password",
      errorMsg: "Current Password is required.",
      invalidMsg: "Your password should be more than 4 characters.",
    },
    password: {
      name: "password",
      label: "New Password",
      type: "password",
      errorMsg: "Password is required.",
      invalidMsg: "Your password should be more than 6 characters.",
    },
    confirmPassword: {
      name: "confirmPassword",
      label: "Confirm New Password",
      type: "password",
      errorMsg: "Password is required.",
      invalidMsg: "Your password doesn't match.",
    },
  },
};
